export default "__VITE_ASSET__Ml6RqUCa__"